import React, { Component } from "react";
import "../../css/LangSelect.css";

class LangSelect extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false, activeIndex: 0 };

    // колбэк-рефы
    this.setButtonRef = (el) => { this.buttonRef = el; };
    this.setListRef   = (el) => { this.listRef   = el; };
    this.setRootRef   = (el) => { this.rootRef   = el; };

    this.options =
      (props.options && props.options.length ? props.options : [
        { value: "ru", label: "Рус" },
        { value: "kk", label: "Қаз" },
        { value: "en", label: "Eng" },
      ]);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (e) => {
    if (this.rootRef && !this.rootRef.contains(e.target)) {
      this.setState({ open: false });
    }
  };

  handleButtonKeyDown = (e) => {
    const { value } = this.props;
    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      e.preventDefault();
      this.setState({
        open: true,
        activeIndex: Math.max(0, this.options.findIndex((o) => o.value === value)),
      });
      setTimeout(() => { if (this.listRef) this.listRef.focus(); }, 0);
    }
  };

  handleListKeyDown = (e) => {
    const { activeIndex } = this.state;

    if (e.key === "Escape") {
      this.setState({ open: false });
      if (this.buttonRef) this.buttonRef.focus();
      return;
    }
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      const item = this.options[activeIndex];
      if (item) {
        if (typeof this.props.onChange === "function") this.props.onChange(item.value);
        this.setState({ open: false });
        if (this.buttonRef) this.buttonRef.focus();
      }
      return;
    }
    if (e.key === "ArrowDown") {
      e.preventDefault();
      this.setState({ activeIndex: (activeIndex + 1) % this.options.length });
      return;
    }
    if (e.key === "ArrowUp") {
      e.preventDefault();
      this.setState({
        activeIndex: (activeIndex - 1 + this.options.length) % this.options.length,
      });
      return;
    }
  };

  handleSelect = (val) => {
    if (typeof this.props.onChange === "function") this.props.onChange(val);
    this.setState({ open: false });
    if (this.buttonRef) this.buttonRef.focus();
  };

  render() {
    const { value } = this.props;
    const { open, activeIndex } = this.state;
    const selected = this.options.find((o) => o.value === value) || this.options[0];

    return (
      <div ref={this.setRootRef} className="lang-select-root">
        <button
          ref={this.setButtonRef}
          type="button"
          className={`trigger ${open ? "open" : ""}`}
          aria-haspopup="listbox"
          aria-expanded={open}
          onClick={() => this.setState({ open: !open })}
          onKeyDown={this.handleButtonKeyDown}
        >
          <span className="lang-label">{selected.label}</span>
          <svg className="caret" width="12" height="12" viewBox="0 0 20 20" aria-hidden="true">
            <path d="M5 8l5 5 5-5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>

        {open ? (
          <ul
            ref={this.setListRef}
            tabIndex={-1}
            role="listbox"
            aria-activedescendant={`opt-${activeIndex}`}
            className="menu"
            onKeyDown={this.handleListKeyDown}
          >
            {this.options.map((opt, i) => {
              const isSelected = value === opt.value;
              const active = i === activeIndex;
              return (
                <li
                  id={`opt-${i}`}
                  key={opt.value}
                  role="option"
                  aria-selected={isSelected}
                  className={`item ${isSelected ? "selected" : ""} ${active ? "active" : ""}`}
                  onMouseEnter={() => this.setState({ activeIndex: i })}
                  onClick={() => this.handleSelect(opt.value)}
                >
                  {opt.label}
                </li>
              );
            })}
          </ul>
        ) : null}
      </div>
    );
  }
}

export default LangSelect;
